import { useState, useMemo, useEffect, useContext } from "react";
import { useSelector } from "react-redux";

import { Button, COLORS, Modal, Tab } from "abs-ui-components";

import BreadCrumb from "../../../common/breadCrumb/BreadCrumb";
import UserDetails from "./UserDetails";
import RoleDetails from "./RoleDetails";
import ManageWCNPage from "./ManageWCN";
import { useNavigate } from "react-router-dom";
import { ClaimsContext } from "../../../services/ClaimsService";
import { ClaimType } from "../../../constants/claims";

const AdminPage = () => {
	const autoTab = useSelector((state) => state.admin.selectedTab);
	const [activeTab, setActiveTab] = useState(autoTab || 0);
	const [authorized, setAuthorized] = useState();
	const navigate = useNavigate();
	const { userHasClaim, userClaimsAreLoaded } = useContext(ClaimsContext);

	useEffect(() => {
		const hasAccess = userHasClaim(ClaimType.VIEW_ADMIN);
		setAuthorized(hasAccess);
	}, [userClaimsAreLoaded])

	const tabData = useMemo(
		() => [
			{
				header: "users",
				breadcrumbId: "Manage Users",
				content: <>{activeTab === 0 && <UserDetails />}</>,
			},

			{
				header: "roles",
				breadcrumbId: "Manage Roles",
				content: <>{activeTab === 1 && <RoleDetails />}</>,
			},
			{
				header: "Manage wcn",
				breadcrumbId: "Manage WCN",
				content: <>{activeTab === 2 && <ManageWCNPage />}</>,
			},
		],
		[activeTab]
	);

	const tabChangeHandler = (event) => {
		setActiveTab(event);
	};

	const breadcrumb = useMemo(
		() => [
			{
				label: "Admin",
				url: "/admin",
				navId: "admin_navId",
			},
			{
				label: tabData[activeTab]?.breadcrumbId,
				url: "/admin",
				navId: `${tabData[activeTab]?.breadcrumbId}details_navId`,
			},
		],
		[activeTab, tabData]
	);

	const handleOk = () => {
		navigate("/");
	};

	useEffect(() => {
		setActiveTab(autoTab || 0);
	}, [autoTab]);

	useEffect(() => {
		if (!authorized) {
			document.body.style.backgroundColor = "white";
		} else {
			document.body.style.backgroundColor = "";
		}

		return () => {
			document.body.style.backgroundColor = "";
		};
	}, [authorized]);

	return (
		<>
			{authorized ? (
				<div>
					<div className="actions-top p-3">
						<BreadCrumb items={breadcrumb} />
					</div>
					<div>
						<h2 className="pl-3">
							Digital Platform Administration
						</h2>
					</div>
					<div className="report-details p-1">
						<Tab
							tabData={tabData}
							onTabChange={tabChangeHandler}
							activeTab={activeTab}
						></Tab>
					</div>
				</div>
			) : (
				<div>
					<Modal
						isOpen={!authorized}
						modalHeader
						padding={"70px"}
						headerHeight={"50px"}
						showFooter
						footer={
							<div className="d-flex justify-content-end fixed-action-btns p-4">
								<Button
									className="modal-delete-btn"
									onClick={handleOk}
									primaryColor={COLORS.RED.DARK}
									primaryBackgroundColor={COLORS.RED.LIGHT}
								>
									Ok
								</Button>
							</div>
						}
					>
						<div>You are not authorized to view this.</div>
					</Modal>
				</div>
			)}
		</>
	);
};

export default AdminPage;
